import React from "react";

const defaultTraditionalKnowledgeData = [
  {
    knowledge: "",
    owned: "",
    benefitShared: "",
    basis: "",
  },
];

const TraditionalKnowledgeTable = ({
  traditionalKnowledgeData,
  setTraditionalKnowledgeData,
}) => {
  const handleChange = (index, field, value) => {
    const updated = [...traditionalKnowledgeData];
    updated[index][field] = value;
    setTraditionalKnowledgeData(updated);
  };

  const addRow = () => {
    setTraditionalKnowledgeData([
      ...traditionalKnowledgeData,
      {
        knowledge: "",
        owned: "",
        benefitShared: "",
        basis: "",
      },
    ]);
  };

  const removeRow = () => {
    if (traditionalKnowledgeData.length > 1) {
      setTraditionalKnowledgeData(traditionalKnowledgeData.slice(0, -1));
    }
  };

  const cell = {
    border: "1px solid #000",
    padding: "15px",
    textAlign: "left",
    verticalAlign: "top",
  };

  const header = {
    ...cell,
    backgroundColor: "#d3c9ce",
    fontWeight: "bold",
    textAlign: "center",
  };

  const inputStyle = {
    width: "100%",
    padding: "15px",
    border: "1px solid gray",
    borderRadius: "4px",
    fontSize: "14px",
  };

  return (
    <div>
      <div
        style={{
          overflowX: "auto",
          marginTop: 20,
          border: "1px solid #000",
          overflow: "hidden",
          borderRadius: "8px",
        }}
      >
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr>
              <th style={header}>S. No</th>
              <th style={header}>
                Intellectual Property based on <br /> traditional knowledge
              </th>
              <th style={header}>Owned / Acquired (Yes / No)</th>
              <th style={header}>Benefit shared (Yes / No)</th>
              <th style={header}>Basis of calculating benefit share</th>
            </tr>
          </thead>
          <tbody>
            {traditionalKnowledgeData.map((row, index) => (
              <tr key={index}>
                <td style={cell}>{index + 1}.</td>
                <td style={cell}>
                  <input
                    type="text"
                    placeholder="Details"
                    value={row.knowledge}
                    onChange={(e) =>
                      handleChange(index, "knowledge", e.target.value)
                    }
                    style={inputStyle}
                  />
                </td>
                <td style={cell}>
                  <input
                    type="text"
                    placeholder="Yes / No"
                    value={row.owned}
                    onChange={(e) =>
                      handleChange(index, "owned", e.target.value)
                    }
                    style={inputStyle}
                  />
                </td>
                <td style={cell}>
                  <input
                    type="text"
                    placeholder="Yes / No"
                    value={row.benefitShared}
                    onChange={(e) =>
                      handleChange(index, "benefitShared", e.target.value)
                    }
                    style={inputStyle}
                  />
                </td>
                <td style={cell}>
                  <input
                    type="text"
                    placeholder="Detail"
                    value={row.basis}
                    onChange={(e) =>
                      handleChange(index, "basis", e.target.value)
                    }
                    style={inputStyle}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          marginTop: "10px",
          gap: "10px",
        }}
      >
        <button onClick={removeRow} style={removeButtonStyle}>
          - Remove
        </button>
        <button onClick={addRow} style={addButtonStyle}>
          + Add More
        </button>
      </div>
    </div>
  );
};

const addButtonStyle = {
  backgroundColor: "white",
  border: "1px solid lightgrey",
  color: "grey",
  borderRadius: "4px",
  padding: "8px 12px",
  cursor: "pointer",
};

const removeButtonStyle = {
  backgroundColor: "white",
  border: "1px solid lightgrey",
  color: "grey",
  borderRadius: "4px",
  padding: "8px 12px",
  cursor: "pointer",
};

export default TraditionalKnowledgeTable;
